(function($) {
    /**
     * @class ABDOMap.OverlayLink 
     */
    $.OverlayLink = function(){
        this._component_name = 'overlay_link';
        $.Component.call(this, $.OverlayLink);
    };

    $.Component.create($.OverlayLink, {
        _init_: function (options) {
            this.viewers = this.parent.viewers;

            this._options = options || {};
            this.lines = []; 
            this._btn_nearest_overlay = this._options.btn_nearest_overlay || 'button.btn-nearest-overlay';
            if (typeof(this._btn_nearest_overlay) === 'string') {
                this._btn_nearest_overlay = document.querySelector(this._btn_nearest_overlay);
            }
            this._nearest_overlay_selector = this._options.nearest_overlay_selector || '.abdo-overlay';

            if (typeof(this._options.pan_to_overlay) === 'undefined') {
                this._pan_to_overlay = false;
            }
            else {
                this._pan_to_overlay = this._options.pan_to_overlay;
            }

            // Overlay link line with properties
            var line_defaults = {
                strokeStyle: "red",
                lineWidth: 5,
                shadowOffsetX: 4,
                shadowOffsetY: 4,
                shadowBlur: 7,
                shadowColor: "gray"
            }; 
            // override defaults with specified in settings
            options.line = options.line || {};
            this._line = line_defaults;
            for(var prop in options.line) {
                if (options.line.hasOwnProperty(prop)) {
                    this._line[prop] = options.line[prop];
                }
            }

            this._leader_line = options.leader_line || { path: "straight", color: "rgb(255,0,0)", dropShadow: true };

            this._tracker = null;
            this._link_init();
        },
        
        _link_init: function() {
            var osd = this.parent.parent; // hierarchy: osd <- overlay <- overlay_link
            this._tracker = osd.tracker || null; // hierarchy: osd -> tracker

            if (!this._tracker) {
                return;
            }
  
            if (this._btn_nearest_overlay) { 
                this._btn_nearest_overlay.addEventListener(ABDOUtil.getClickHandler(this._btn_nearest_overlay), this._btnClick.bind(this, this._btn_nearest_overlay));
            }
            
            // 現在地の追跡した後毎回避難所までの距離を更新する 
            if (this._tracker.btnStartTracking) { 
                this._tracker._on(this._tracker._events.finished_tracking, this._on_finished_tracking.bind(this));
            }

            // openseadragonの画面は更新する必要があるとき 
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                viewer.addHandler('update-viewport', this._update_viewport.bind(this));
                // this._tracker._on(this._tracker._events.finished_tracking)
                viewer.addHandler('update-overlay', this._update_overlay.bind(this));
            }

            // オーバーレイのクリックイベント 
            this.parent._on(this.parent._events.clicked, this._overlayLinkClicked.bind(this));

            this._tracker._on(this._tracker._events.reset_tracking, this.reset.bind(this));
        }, 

        _on_finished_tracking: function(event) {  
        }, 

        /**
         * Object that stores Overlay Extra information
         * @typedef {Object} OverlayInfo
         * @property {OpenSeadragon.Overlay} overlay
         * @property {Number} distance
         */

        /**
         * Gets extra info from overlay.
         * It returns distance from location overlay from now
         * @param {String} id 
         * @param {OpenSeadragon.Overlay} location_overlay 
         * @returns {OverlayInfo}
         */
        getOverlayInfo: function(id, location_overlay) {
            var i, viewer;
            for (i = 0; i < this.viewers.length; i++) {
                viewer = this.viewers[i];
                var overlay = viewer.getOverlayById(id);
                if (typeof(viewer.abdo.localization) !== "undefined") {
                    return {
                        overlay: overlay,
                        distance: viewer.abdo.localization.point_distance(location_overlay.location, overlay.location)
                    };
                }
            } 

            return {};
        },

        /**
         * 
         * @param {OpenSeadragon.Viewer} viewer 
         * @returns {OverlayInfo[]}
         */
        nearestOverlay: function(viewer) {
            var abdo = ABDOUtil.get_abdo(viewer);
            if (abdo) { 
                if (abdo.location_overlay) {
                    var overlay_elements = viewer.element.querySelectorAll(this._nearest_overlay_selector);  
                    var overlay_distances = []; // measure distances
                    var i, overlay_n = overlay_elements.length;
                    for (i = 0; i < overlay_n; i++) { 
                        overlay_distances.push(
                            this.getOverlayInfo(overlay_elements[i].id, abdo.location_overlay));
                    } 
        
                    // 最短順でならべる
                    overlay_distances.sort(function(overlayd_a, overlayd_b){
                        return overlayd_a.distance - overlayd_b.distance;
                    });
        
                    this.overlay = overlay_distances;
                    return [overlay_distances[0]]; 
                }  
            }

            return []; 
        }, 

        _get_overlays_bb: function(overlays) {
            var min_x = Number.MAX_VALUE;
            var min_y = Number.MAX_VALUE;
            var max_x = 0.0;
            var max_y = 0.0;  
            
            for (var index = 0; index < overlays.length; index++) {
                var overlay = overlays[index];
                if (overlay.location.x < min_x) {
                    min_x = overlay.location.x;
                }
                if (overlay.location.y < min_y) {
                    min_y = overlay.location.y;
                }

                if (overlay.location.x > max_x) {
                    max_x = overlay.location.x;
                }
                if (overlay.location.y > max_y) {
                    max_y = overlay.location.y;
                }
            } 

            return {
                min_x: min_x,
                min_y: min_y,
                max_x: max_x,
                max_y: max_y
            };
        },

        _get_overlays_rect: function(viewer, overlays) {
            var abdo = viewer.abdo;
            var localization = abdo.localization;
            if (localization) {
                var obb = this._get_overlays_bb(overlays);
    
                var width = obb.max_x - obb.min_x;
                var height = obb.max_y - obb.min_y;  
    
                var min_pt = new OpenSeadragon.Point(obb.min_x, obb.min_y);
                var max_pt = new OpenSeadragon.Point(obb.max_x, obb.max_y);
                var rect_length = localization.point_distance(min_pt, max_pt);
                var MIN_LENGTH = 100.0; // 100 meters
                var scale = rect_length < MIN_LENGTH ? MIN_LENGTH / rect_length : 1.0;
                
                width = width*scale;
                height = height*scale;
    
                //var visible_rect = new OpenSeadragon.Rect(obb.min_x, obb.min_y, width, height, 0);
                return new OpenSeadragon.Rect(
                    min_pt.x - width *0.5, 
                    min_pt.y - height*0.5, 
                    width*2.2, height*2.2, 
                    0);
            }
        },

        /**
         * Pan viewer to nearestOverlay
         * @param {OpenSeadragon.Viewer} viewer 
         * @param {OverlayInfo[]} nearestOverlay 
         */
        _pan_to_nearest_overlay: function(viewer, nearestOverlay) {
            // todo: decompose into functions, probably some in ABDOUtil
            if (this._pan_to_overlay) {
                var abdo = ABDOUtil.get_abdo(viewer);
                if (abdo && typeof(abdo.location_overlay) !== "undefined") { 
                    var overlays = [nearestOverlay[0].overlay, abdo.location_overlay];
    
                    var visible_rect = this._get_overlays_rect(viewer, overlays);
                    
                    viewer.viewport.fitBoundsWithConstraints(visible_rect, true);
    
                    var chkEnableScroll = document.getElementById('chkEnableScroll');
                    if (chkEnableScroll) {
                        chkEnableScroll.checked = false;
                    }
                }

            }
        },

        _btnClick: function(btn, evt) { 
            if (!this._tracker) {
                return;
            }

            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                var viewer = this.viewers[i];
                var abdo = ABDOUtil.get_abdo(viewer);

                if (typeof(abdo.location_overlay) === "undefined" && abdo.location_overlay.element.parentElement) {  
                    //　現在地の追跡の一回が終わったら一回下記の関数が呼び出されている
                    this._tracker._once(this._tracker._events.finished_tracking, this._btnClick.bind(this));
                    this._tracker.btnStartTrackingClick();
        
                    return;
                }

                // from here it is ensured abdo.location_overlay != undefined
        
                var nearest_overlay = this.nearestOverlay(viewer);
                if (nearest_overlay.length > 0)
                {
                    jQuery('.dot').each(function(index, element){
                        element.classList.remove('dot');
                    });
    
                    jQuery('.distance').each(function(index, element){
                        element.classList.remove('distance');
                    });
                    
                    nearest_overlay[0].overlay.element.classList.add('dot'); 
                    this._pan_to_nearest_overlay(viewer, nearest_overlay);
                    
                    this._reset_lines();
                    abdo.lines = [{ 
                        current_location: abdo.location_overlay,
                        overlay_data: nearest_overlay[0]
                    }];
    
                    this._refresh_canvas(viewer);
                }
            }
             
            
        },

        _refresh_canvas: function(viewer) {
            // forces OpenSeadragon to refresh canvas properly 
            viewer.world.draw();
            viewer.raiseEvent("update-viewport", viewer); 
        },

        /**
         * @typedef {Object} LineLike
         * @property {OpenSeadragon.Overlay} current_location
         * @property {OpenSeadragon.Overlay} current_location
         */

        /**
         * Draws the specified line in the canvas 
         * @param {LineLike} line 
         * @returns 
         */
        _draw_canvas_line: function(line) {
            
            if (document.getElementById(line.current_location.element.id) == null) {
                return;
            }
            
            var viewer = line.current_location.viewer;
            if (viewer) {
                var pixelDensityRatio = OpenSeadragon.pixelDensityRatio;
                var ctx = viewer.drawer.canvas.getContext("2d");

                var genzaichi = viewer.viewport.pixelFromPoint(line.current_location.location, true);
                var overlay = viewer.viewport.pixelFromPoint(line.overlay_data.overlay.location, true); 

                if (typeof(viewer.abdo.localization) !== "undefined") {
                    // estimate distance in projected coordinates
                    var current_projected = viewer.abdo.localization.vp2proj(line.current_location.location.x,     line.current_location.location.y);
                    var target_projected  = viewer.abdo.localization.vp2proj(line.overlay_data.overlay.location.x, line.overlay_data.overlay.location.y);
                    var current_pt = new OpenSeadragon.Point(current_projected[0], current_projected[1]);
                    var target_pt  = new OpenSeadragon.Point(target_projected[0], target_projected[1]);
                    line.overlay_data.distance = current_pt.distanceTo(target_pt);
                }
                else {
                    line.overlay_data.distance = "";
                }
    
                // draw line
                ctx.beginPath();
    
                // save modified context variables
                var prev_values = {};
                for(var prop in this._line) {
                    if (this._line.hasOwnProperty(prop) && prop in ctx) {
                        prev_values[prop] = ctx[prop];
                        ctx[prop] = this._line[prop];
                    }
                }
    
                ctx.moveTo(genzaichi.x * pixelDensityRatio, genzaichi.y * pixelDensityRatio);
                ctx.lineTo(overlay.x * pixelDensityRatio, overlay.y * pixelDensityRatio);
                ctx.stroke();
    
                // restore modified context variables
                for(var prop in prev_values) {
                    if (prev_values.hasOwnProperty(prop) && prop in ctx) { 
                        ctx[prop] = prev_values[prop];
                    }
                } 
            }
        },

        _create_leader_line: function(line) {
            var location_icon = line.current_location.element.querySelector(".icon-location");
            if (location_icon) {
                return new LeaderLine(
                    LeaderLine.pointAnchor(location_icon, {x: "50%", y: "50%"}), 
                    LeaderLine.pointAnchor(line.overlay_data.overlay.element, {x: "50%", y: "50%"}), 
                    this._leader_line);
            }
            else { 
                return undefined; 
            }
        },

        _draw_leader_line: function(line) {
            if (typeof(line.leader_line) === "undefined") {
                line.leader_line = this._create_leader_line(line); 
            }
            else {
                if (window.getComputedStyle(line.overlay_data.overlay.element).display === "none") {
                    line.leader_line.hide(); 
                }
                else {
                    line.leader_line.show();
                    line.leader_line.position();

                    // disabled due to conflicts with jquery-ui and performance concerns
                    // window.dispatchEvent(new Event('resize'));  
                }
            }
        },

        _update_viewport: function(evt) {
            var viewer = evt.eventSource;
            var abdo = ABDOUtil.get_abdo(viewer);
            if (viewer && abdo && Array.isArray(abdo.lines)) {
                var index, line;
                for (index = 0; index < abdo.lines.length; index++) {
                    line = abdo.lines[index]; 
                    this._draw_line(line); 
                    this.showDistance(line.overlay_data.overlay, line.overlay_data.distance.toFixed(1));
                }
            }  
        }, 

        _draw_line: function(line) {
            // LeaderLine support temporarily disabled
            // if (typeof(LeaderLine) === "undefined") {
            //     this._draw_canvas_line(line);
            // }
            // else {
            //     this._draw_leader_line(line);
            // }

            this._draw_canvas_line(line);
        },

        _update_overlay: function(evt) { 
            var viewer = evt.eventSource;
            var abdo = ABDOUtil.get_abdo(viewer);
            if (abdo && Array.isArray(abdo.lines)) {
                var index, line;
                for (index = 0; index < abdo.lines.length; index++) {
                    line = abdo.lines[index];

                    if (evt.element == line.current_location.element) {
                        this._draw_line(line);
                        
                        this.showDistance(
                            line.overlay_data.overlay, 
                            line.overlay_data.distance.toFixed(1)); 
                    }  
                }
            } 
        },

        _reset_lines: function() {
            var i, viewer;
            for(i = 0; i < this.viewers.length; i++) {
                var viewer = this.viewers[i];
                var abdo = ABDOUtil.get_abdo(viewer);

                abdo.lines = [];

                if (typeof(abdo.leader_line) !== "undefined") {
                    abdo.leader_line.remove();
                }
            } 
        }, 

        _overlayLinkClicked: function(evt, overlay_element, overlay_osd) { 
            if (overlay_element.classList.contains('abdo-overlay-nolink')) {
                return;
            }
            
            var viewer = overlay_osd.viewer;
            var abdo = ABDOUtil.get_abdo(viewer);
             
            if (typeof(abdo.lines) === "undefined") {
                abdo.lines = [];
            }

            // if it has location_overlay and it is added to the DOM (active)
            if (viewer && abdo && abdo.location_overlay && abdo.location_overlay.element.parentElement) {
                var location_overlay = abdo.location_overlay; 
                // 同じ避難所を選択すると消す
                if(abdo.lines.length > 0 && abdo.lines[0].overlay_data.overlay.element.id == overlay_element.id) {
                    this._reset_lines();
                    overlay_element.classList.remove('dot');
                    this.resetDistance(overlay_element.id);
                }
                else {
                    var current_evacuation = document.getElementsByClassName('dot');
                    var index, current_evacuation_n = current_evacuation.length;
                    for (index = 0; index < current_evacuation_n; index++) {
                        var element = current_evacuation[index];
                        element.classList.remove('dot');
                        element.classList.remove('distance');
                    }

                    overlay_element.classList.add('dot');

                    var overlay_info = this.getOverlayInfo(overlay_element.id, location_overlay);
                    this._reset_lines();
                    abdo.lines = [{ 
                        current_location: location_overlay,
                        overlay_data: overlay_info
                    }];
                }

                this._refresh_canvas(viewer); 
            }
            
        },

        showDistance: function(overlay, distance) {  
            var viewer = overlay.viewer;
            if(viewer) {
                var overlay_element = overlay.element;
    
                overlay_element.dataset.distance = distance + 'm';
                if (!overlay_element.classList.contains('distance')) {
                    overlay_element.classList.add('distance');
                }
                
                viewer.updateOverlay({element: this.distance_id, location: overlay.location}); 
            }
        },

        resetDistance: function(overlay_id) {
            var overlay_element = document.getElementById(overlay_id);
            overlay_element.dataset.distance = '';
            overlay_element.classList.remove('distance'); 
        }, 

        reset: function() {
            jQuery('.dot').each(function(index, element){
                element.classList.remove('dot');
            });
            
            jQuery('.distance').each(function(index, element){
                element.classList.remove('distance');
            });
            this._reset_lines();
        }
    }, $.Overlay); 
}(ABDOMap));